"use client";

import { useState, useTransition } from "react";
import { Mail, Loader2, Send } from "lucide-react";
import { requestPasswordReset } from "@/lib/actions";
import type { Messages } from "@/lib/i18n";

export function ForgotForm({ m }: { m: Messages["auth"] }) {
  const [sent, setSent] = useState(false);
  const [pending, startTransition] = useTransition();

  const onSubmit = (formData: FormData) => {
    const email = String(formData.get("email") ?? "");
    startTransition(async () => {
      await requestPasswordReset(email);
      setSent(true);
    });
  };

  if (sent) {
    return (
      <>
        <p className="lf-ok">{m.forgotSent}</p>
        <a className="auth-link" href="/login">
          <span aria-hidden="true">&larr;</span> {m.backToLogin}
        </a>
      </>
    );
  }

  return (
    <form action={onSubmit} className="w-full">
      <div className="lf-field">
        <label className="lf-label" htmlFor="fp-email">{m.emailLabel}</label>
        <div className="lf-inwrap">
          <Mail className="lf-ic" strokeWidth={2} />
          <input
            id="fp-email"
            autoFocus
            required
            type="email"
            name="email"
            placeholder={m.emailPlaceholder}
            autoComplete="email"
            className="lf-input"
          />
        </div>
      </div>

      <button type="submit" disabled={pending} className="lf-submit">
        {pending ? <Loader2 className="size-4 animate-spin" /> : <Send className="size-4" strokeWidth={2.2} />}
        {pending ? m.forgotSending : m.forgotSubmit}
      </button>

      <a className="auth-link" href="/login">
        <span aria-hidden="true">&larr;</span> {m.backToLogin}
      </a>
    </form>
  );
}
